(window["webpackJsonp"] = window["webpackJsonp"] || []).push([["main"],{

/***/ "./$$_lazy_route_resource lazy recursive":
/*!******************************************************!*\
  !*** ./$$_lazy_route_resource lazy namespace object ***!
  \******************************************************/
/*! no static exports found */
/***/ (function(module, exports) {

function webpackEmptyAsyncContext(req) {
	// Here Promise.resolve().then() is used instead of new Promise() to prevent
	// uncaught exception popping up in devtools
	return Promise.resolve().then(function() {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	});
}
webpackEmptyAsyncContext.keys = function() { return []; };
webpackEmptyAsyncContext.resolve = webpackEmptyAsyncContext;
module.exports = webpackEmptyAsyncContext;
webpackEmptyAsyncContext.id = "./$$_lazy_route_resource lazy recursive";

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/app.component.html":
/*!**************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/app.component.html ***!
  \**************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<div class=\"\">\r\n    <app-header>\r\n    </app-header>\r\n</div>\r\n<body>\r\n    <router-outlet></router-outlet>\r\n</body>\r\n<!-- footer -->\r\n<div>\r\n    <app-footer></app-footer>\r\n</div>\r\n<!-- footer ends -->");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/modules/core/contact-us/contact-us.component.html":
/*!*********************************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/modules/core/contact-us/contact-us.component.html ***!
  \*********************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<p>contact-us works!</p>\r\n");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/modules/core/content-page/content-page.component.html":
/*!*************************************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/modules/core/content-page/content-page.component.html ***!
  \*************************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<app-loader *ngIf=\"showloader\"></app-loader>\r\n\r\n<div class=\"container section-content\">\r\n  <h3 class=\"text-center\">{{contentData?.title}}</h3>\r\n  <h4 class=\"text-center\">{{contentData?.sub_title}}</h4>\r\n  <div *ngIf=\"contentData?.media.length == 1\">\r\n    <img *ngIf=\"contentData?.media[0].show_img\" [src]=\"'http://stfrancisschoolkorba.ac.in/'+(contentData?.media[0]?.media_file)\" alt=\"\" style=\" width:25rem\"\r\n      class=\"img-thumbnail  mx-auto d-block\">\r\n      <h4 class=\"text-center\">\r\n          <i class=\"fa fa-download\" *ngIf=\"!contentData?.media[0].show_img\" title=\"{{contentData?.title}}\" (click)=\"downloadFile(contentData?.media[0]?.media_file.slice(30))\"></i>\r\n      </h4>\r\n  </div>\r\n  <p class=\"lead content-align\">{{contentData?.content}}</p>\r\n  <span class=\"row\" *ngIf=\"contentData?.media.length > 1\">\r\n    <div class=\"column has-text-centered\">\r\n        <h4 class=\"float-right\">\r\n            <i class=\"fa fa-download\" *ngIf=\"contentData?.title == 'School Event'\" title=\"{{contentData?.title}}\" (click)=\"download()\"></i>\r\n        </h4>\r\n      <div>\r\n          <div class=\"row card-deck\">\r\n            <div class=\"col-md-12\" *ngFor=\"let image of contentData?.media | keyvalue\">\r\n              <div class=\"card shadow p-3 mb-5 bg-white rounded\"  data-toggle=\"tooltip\"\r\n                data-placement=\"top\" title=\"{{image.value.title}}\">\r\n                <img *ngIf=\"image.value.show_img\" class=\"card-img-top img-fluid\" [src]=\"'http://stfrancisschoolkorba.ac.in/'+(image.value.media_file)\" alt=\"image.value.title\" (click)=\"open(image.key)\">\r\n                <h4 class=\"text-center\">\r\n                    <i class=\"fa fa-download\" *ngIf=\"!image.value.show_img\" title=\"{{image.value.title}}\" (click)=\"downloadFile(image.value.media_file.slice(30))\"></i>\r\n                </h4>\r\n\r\n                <h3 class=\"card-title text-center\">{{image.value.title}}\r\n                </h3>\r\n                <div class=\"card-body text-justify\" >\r\n                  {{image.value.content}}\r\n                </div>\r\n              </div>\r\n            </div>\r\n          </div>\r\n      </div>\r\n    </div>\r\n\r\n  </span>\r\n\r\n  <!-- FOR FACULTY STAFF  -->\r\n\r\n  <section class=\"our-webcoderskull padding-lg\" *ngIf=\"pageSlug == 'faculty-staff-images' || pageSlug == 'administrative-departmente02bfce4-016a-4902-90e1-c2a1e323db98'\">\r\n      <div class=\"container\">\r\n          <div class=\"row heading heading-icon\">\r\n          </div>\r\n          <ul class=\"row\">\r\n              <li class=\"col-12 col-md-6 col-lg-3\" *ngFor=\"let val of facultyData;\">\r\n                  <div class=\"cnt-block equal-hight\" style=\"height: 349px;\">\r\n                      <!-- <figure><img [src]=\"val.profile_image ? (val.profile_image).slice(30): ''\" class=\"img-responsive\" alt=\"\"></figure> -->\r\n                      <figure><img [src]=\"val.profile_image ? 'http://stfrancisschoolkorba.ac.in/'+(val.profile_image): ''\" class=\"img-responsive\" alt=\"\"></figure>\r\n                      <h3>{{val.full_name | titlecase}}</h3>\r\n                      <h5>{{val?.education}}</h5>\r\n                      <h5>{{val?.job_title}}</h5>\r\n                      <h5>{{val?.contact_number}}</h5>\r\n                  </div>\r\n              </li>\r\n          </ul>\r\n      </div>\r\n  </section>\r\n\r\n</div>\r\n\r\n\r\n");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/modules/core/event-detail/event-detail.component.html":
/*!*************************************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/modules/core/event-detail/event-detail.component.html ***!
  \*************************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<app-loader *ngIf=\"showloader\"></app-loader>\n\n<div class=\"container section-content\">\n  <h3 class=\"text-center\">{{contentData?.title}}</h3>\n  <h4 class=\"text-center\">{{contentData?.sub_title}}</h4>\n  <!-- <div *ngIf=\"contentData?.media.length == 1\">\n    <img *ngIf=\"contentData?.media.show_img\" [src]=\"(contentData?.media?.media_file).slice(30)\" alt=\"\" style=\" width:25rem\"\n      class=\"img-thumbnail  mx-auto d-block\">\n      <h4 class=\"text-center\">\n          <i class=\"fa fa-download\" *ngIf=\"!contentData?.media.show_img\" title=\"{{contentData?.title}}\" (click)=\"downloadFile(contentData?.media?.media_file.slice(30))\"></i>\n      </h4>\n  </div> -->\n\n  <div class=\"column has-text-centered\">\n\n    <div>\n        <div class=\"row card-deck\">\n          <div class=\"col-md-12\">\n            <div class=\"card shadow p-3 mb-5 bg-white rounded\"  data-toggle=\"tooltip\"\n              data-placement=\"top\" title=\"{{contentData?.title}}\">\n              <img class=\"card-img-top img-fluid\" [src]=\"(contentData?.media_file).slice(63)\" alt=\"\" (click)=\"open(contentData?.id)\">\n              <!-- <h4 class=\"text-center\">\n                  <i class=\"fa fa-download\" *ngIf=\"!contentData.show_img\" title=\"{{contentData.title}}\" (click)=\"downloadFile(contentData.media_file.slice(30))\"></i>\n              </h4> -->\n\n              <!-- <h3 class=\"card-title text-center\">{{contentData?.title}}\n              </h3> -->\n              <div class=\"card-body text-justify\" >\n                {{contentData?.content}}\n              </div>\n            </div>\n          </div>\n        </div>\n    </div>\n  </div>\n\n\n  <p class=\"lead content-align\">{{contentData?.content}}</p>\n  <!-- <span class=\"row\" *ngIf=\"contentData?.media.length > 1\"> -->\n    <!-- <div class=\"column has-text-centered\">\n\n      <div>\n          <div class=\"row card-deck\">\n            <div class=\"col-md-12\" *ngFor=\"let image of contentData?.media | keyvalue\">\n              <div class=\"card shadow p-3 mb-5 bg-white rounded\"  data-toggle=\"tooltip\"\n                data-placement=\"top\" title=\"{{image.value.title}}\">\n                <img *ngIf=\"image.value.show_img\" class=\"card-img-top img-fluid\" [src]=\"(image.value.media_file).slice(30)\" alt=\"image.value.title\" (click)=\"open(image.key)\">\n                <h4 class=\"text-center\">\n                    <i class=\"fa fa-download\" *ngIf=\"!image.value.show_img\" title=\"{{image.value.title}}\" (click)=\"downloadFile(image.value.media_file.slice(30))\"></i>\n                </h4>\n\n                <h3 class=\"card-title text-center\">{{image.value.title}}\n                </h3>\n                <div class=\"card-body text-justify\" >\n                  {{image.value.content}}\n                </div>\n              </div>\n            </div>\n          </div>\n      </div>\n    </div> -->\n\n  <!-- </span> -->\n</div>\n\n\n");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/modules/core/event/event.component.html":
/*!***********************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/modules/core/event/event.component.html ***!
  \***********************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("  <!-- Event carosel -->\r\n  <div class=\"container\">\r\n      <div id=\"dataInfo\">\r\n        <div id=\"myCarousel\" class=\"carousel slide\" data-ride=\"carousel\">\r\n          <div class=\"carousel-inner\">\r\n            <div class=\"carousel-item active\">\r\n              <div class=\"row\">\r\n                <div class=\"col-12\">\r\n                  <div class=\"card\" style=\"min-height: 30rem;\" (click)=\"viewDetailPage(pageData)\">\r\n                    <img class=\"event-img\" [src]=\"(pageData?.media_file).slice(63)\" alt=\"Card image cap\">\r\n                    <div class=\"card-body\">\r\n                      <h4 class=\"card-title\">{{pageData?.title}}</h4>\r\n                      <p class=\"card-text\">{{pageData?.content |  slice:0:200}}<span *ngIf=\"pageData?.content.length > 200\"><a\r\n                        routerLink=\"{{pageData?.slug}}\">...Read More</a></span></p>\r\n                      <p class=\"card-text\"><small class=\"text-muted\">{{pageData?.date_added | date: 'dd/MM/yyyy'}}</small></p>\r\n                    </div>\r\n                  </div>\r\n                </div>\r\n              </div>\r\n            </div>\r\n          </div>\r\n          <a class=\"carousel-control-prev\" href=\"#myCarousel\" role=\"button\" data-slide=\"prev\">\r\n            <span class=\"carousel-control-prev-icon\" aria-hidden=\"true\"></span>\r\n            <span class=\"sr-only\">Previous</span>\r\n          </a>\r\n          <a class=\"carousel-control-next\" href=\"#myCarousel\" role=\"button\" data-slide=\"next\">\r\n            <span class=\"carousel-control-next-icon\" aria-hidden=\"true\"></span>\r\n            <span class=\"sr-only\">Next</span>\r\n          </a>\r\n        </div>\r\n\r\n      </div>\r\n\r\n\r\n    </div>\r\n");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/modules/core/faculty/faculty.component.html":
/*!***************************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/modules/core/faculty/faculty.component.html ***!
  \***************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<div class=\"container section-content\">\r\n    <section class=\"our-webcoderskull padding-lg\">\r\n        <div class=\"container\">\r\n            <div class=\"row heading heading-icon\">\r\n            </div>\r\n            <ul class=\"row\">\r\n                <li class=\"col-12 col-md-6 col-lg-3\" *ngFor=\"let val of facultyData;\">\r\n                    <div class=\"cnt-block equal-hight\" style=\"height: 349px;\">\r\n                        <figure><img [src]=\"val.img\" class=\"img-responsive\" alt=\"\"></figure>\r\n                        <h3>{{val.full_name | titlecase}}</h3>\r\n                        <h5>{{val?.education}}</h5>\r\n                        <h5>{{val?.job_title}}</h5>\r\n                        <h5>{{val?.contact_number}}</h5>\r\n                    </div>\r\n                </li>\r\n            </ul>\r\n        </div>\r\n    </section>\r\n</div>");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/modules/core/landing-page/landing-page.component.html":
/*!*************************************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/modules/core/landing-page/landing-page.component.html ***!
  \*************************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<!-- <p>landing-page works!</p> -->\r\n<!-- header -->\r\n<app-loader *ngIf=\"showloader\"></app-loader>\r\n<div>\r\n  <div class=\"content container-fluid\">\r\n    <!-- college Image -->\r\n    <div class=\"_mainImage container\">\r\n      <img class=\"_image\" src=\"assets/img/school-img.jpg\" alt=\"school-img\">\r\n    </div>\r\n    <!-- college Image ends -->\r\n\r\n    <!-- for(i = 0, i <= data.length, i++) -->\r\n    <!-- if(value == history || value == principalmessage || value == mission || value == vision) -->\r\n    <!-- if condition end -->\r\n    <!-- for loop ends -->\r\n\r\n    <!-- marquee start -->\r\n    <div class=\"container\">\r\n    <marquee onmouseover=\"this.stop();\" onmouseout=\"this.start();\"><a href=\"http://stfrancisschoolkorba.ac.in/#/staff-required5a61cbc5-2be6-4708-a9cf-170e4bc6e96f\" target=\"_blank\">Staff Requirement</a></marquee>\r\n  </div>\r\n  <!-- marquee end -->\r\n\r\n  <!-- event -->\r\n    <div class=\"container\">\r\n      <div class=\"\">\r\n        <span>\r\n          <span class=\"\">\r\n            <app-page-container *ngFor=\"let val of pageData | keyvalue\" [data]=\"val\" class=\"col-12\">\r\n            </app-page-container>\r\n          </span>\r\n          <!-- <app-event [data]=\"val\" *ngIf=\"val?.value.slug == 'history' || val?.value.slug == 'vision' || val?.value.slug == 'mission' || val?.value.slug == 'principalmessage' || val?.value.slug == 'headmistress'\" class=\"content-align\"></app-event> -->\r\n        </span>\r\n      </div>\r\n    </div>\r\n    <hr class=\"container\">\r\n\r\n<!--Start: news events section -->\r\n  <div class=\"container\">\r\n    <h5 *ngIf=\"eventDta.length\">News</h5>\r\n    <div class=\"row\">\r\n      <app-event *ngFor=\"let val of eventDta\" [events]=\"val\" class=\"col-md-4\">\r\n      </app-event>\r\n    </div>\r\n  </div>\r\n<!--End: news events section -->\r\n\r\n\r\n  </div>\r\n</div>\r\n");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/modules/core/page-container/page-container.component.html":
/*!*****************************************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/modules/core/page-container/page-container.component.html ***!
  \*****************************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<!-- <div class=\"card\" >\r\n  <img class=\"card-img-top\" [src]=\"pageData?.value.media[0]?.media_file\" alt=\"Card image cap\">\r\n  <div class=\"card-body\">\r\n    <h5 class=\"card-title\">{{pageData?.value.title}}</h5>\r\n      <p class=\"card-text text-justify\">{{pageData.value.content |  slice:0:300}}<span *ngIf=\"pageData.value.content.length > 300\">........</span></p>\r\n  </div>\r\n  <div class=\"card-footer\">\r\n    <small class=\"text-muted pull-right\"><span><a\r\n      routerLink=\"{{pageData.value.slug}}\">Read More</a></span></small>\r\n  </div>\r\n</div> -->\r\n\r\n  <div class=\"card mb-3\" >\r\n      <div class=\"row no-gutters\">\r\n        <div class=\"col-md-4\">\r\n          <img [src]=\"(pageData?.value.media[0]?.media_file).slice(30)\" class=\"card-img img-card-css\" alt=\"...\">\r\n        </div>\r\n        <div class=\"col-md-8\">\r\n          <div class=\"card-body\">\r\n            <h5 class=\"card-title\">{{pageData?.value.title}}</h5>\r\n            <p class=\"card-text text-justify \">{{pageData.value.content |  slice:0:300}}<span *ngIf=\"pageData.value.content.length > 300\">...</span></p>\r\n            <p class=\"card-text pull-right btn btn-primary\"><a\r\n              routerLink=\"{{pageData.value.slug}}\">Read More</a></p>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </div>\r\n");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/modules/share/footer/footer.component.html":
/*!**************************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/modules/share/footer/footer.component.html ***!
  \**************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<!-- Footer -->\r\n<footer class=\"page-footer font-small blue-grey lighten-5\">\r\n  <!-- #21d192 -->\r\n  <div class=\"footer-last-section\">\r\n    <div class=\"container\">\r\n      <div class=\"row py-4 d-flex align-items-center\">\r\n        <div class=\"col-md-6 col-lg-5 text-center text-md-left mb-4 mb-md-0\">\r\n          <h6 class=\"mb-0\">Get connected with us on social networks!</h6>\r\n        </div>\r\n        <div class=\"col-md-6 col-lg-7 text-center text-md-right\">\r\n          <a class=\"fb-ic\">\r\n            <i class=\"fa fa-facebook-official white-text mr-4\"> </i>\r\n          </a>\r\n          <a class=\"tw-ic\">\r\n            <i class=\"fa fa-instagram white-text mr-4\"> </i>\r\n          </a>\r\n          <a class=\"gplus-ic\">\r\n            <i class=\"fa fa-google-plus-official white-text mr-4\"> </i>\r\n          </a>\r\n        </div>\r\n\r\n      </div>\r\n\r\n    </div>\r\n  </div>\r\n\r\n  <!-- Footer Links -->\r\n  <div class=\"container text-center text-md-left mt-5\">\r\n\r\n    <!-- Grid row -->\r\n    <div class=\"row mt-3 dark-grey-text\">\r\n\r\n      <!-- Grid column -->\r\n      <div class=\"col-md-4 col-lg-4 col-xl-4 mb-4\">\r\n        <a class=\"scrollto img-fluid \"><img src=\"../../assets/img/logo.png\" alt=\"\"></a>\r\n        <!-- Content -->\r\n        <!-- <h6 class=\"text-uppercase font-weight-bold\">Company name</h6> -->\r\n        <!-- <hr class=\"teal accent-3 mb-4 mt-0 d-inline-block mx-auto\" style=\"width: 60px;\"> -->\r\n        <!-- <p>St.Francis English School provides good quality, modern education, including a strong component of culture, inculcation of values, awareness of environment, adventure activities and physical education.</p> -->\r\n\r\n        <div class=\"col-md-3 col-lg-4 col-xl-3 mb-4\" style=\"display:flex\">\r\n\r\n          <!-- Facebook -->\r\n          <!-- <a class=\"fb-ic\">\r\n            <i class=\"fa fa-facebook-official white-text mr-4\"> </i>\r\n          </a> -->\r\n          <!-- Twitter -->\r\n          <!-- <a class=\"tw-ic\">\r\n            <i class=\"fa fa-instagram white-text mr-4\"> </i>\r\n          </a> -->\r\n          <!-- Google +-->\r\n          <!-- <a class=\"gplus-ic\">\r\n            <i class=\"fa fa-google-plus-official white-text mr-4\"> </i>\r\n          </a> -->\r\n        </div>\r\n\r\n      </div>\r\n      <!-- Grid column -->\r\n\r\n      <!-- Grid column -->\r\n      <!-- <div class=\"col-md-2 col-lg-2 col-xl-2 mx-auto mb-4\">\r\n\r\n  \r\n        <h6 class=\"text-uppercase font-weight-bold\">Quick Link</h6>\r\n        <hr class=\"teal accent-3 mb-4 mt-0 d-inline-block mx-auto\" style=\"width: 60px;\">\r\n        <p>\r\n          <a class=\"dark-grey-text\" href=\"#!\">MDBootstrap</a>\r\n        </p>\r\n        <p>\r\n          <a class=\"dark-grey-text\" href=\"#!\">MDWordPress</a>\r\n        </p>\r\n        <p>\r\n          <a class=\"dark-grey-text\" href=\"#!\">BrandFlow</a>\r\n        </p>\r\n        <p>\r\n          <a class=\"dark-grey-text\" href=\"#!\">Bootstrap Angular</a>\r\n        </p>\r\n\r\n      </div> -->\r\n      <!-- Grid column -->\r\n\r\n      <!-- Grid column -->\r\n      <div class=\"col-md-4 col-lg-4 col-xl-4 mx-auto mb-4\">\r\n\r\n        <!-- Links -->\r\n        <h6 class=\"text-uppercase font-weight-bold\">Useful links</h6>\r\n        <hr class=\"teal accent-3 mb-4 mt-0 d-inline-block mx-auto\" style=\"width: 60px;\">\r\n        <p>\r\n          <a class=\"dark-grey-text\" href=\"/school-event\" >School Event</a>\r\n        </p>\r\n        <p>\r\n          <a class=\"dark-grey-text\" href=\"#!\"></a>\r\n        </p>\r\n        <p>\r\n          <a class=\"dark-grey-text\" href=\"#!\"></a>\r\n        </p>\r\n        <p>\r\n          <a class=\"dark-grey-text\" href=\"#!\"></a>\r\n        </p>\r\n\r\n      </div>\r\n      <!-- Grid column -->\r\n\r\n      <!-- Grid column -->\r\n      <div class=\"col-md-4 col-lg-4 col-xl-4 mx-auto mb-md-0 mb-4\">\r\n\r\n        <!-- Links -->\r\n        <h6 class=\"text-uppercase font-weight-bold\">Contact</h6>\r\n        <hr class=\"teal accent-3 mb-4 mt-0 d-inline-block mx-auto\" style=\"width: 60px;\">\r\n        <p>\r\n          <i class=\"fa fa-home mr-3\"></i> Nakthikhar P.O Ghodi,\r\n          Distt : Korba (C.G) 495677 </p>\r\n        <p>\r\n          <i class=\"fa fa-envelope mr-3\"></i> stfrancisschoolnkr@gmail.com</p>\r\n        <p>\r\n          <i class=\"fa fa-phone mr-3\"></i> + 91 94060 37172</p>\r\n        <p>\r\n          <i class=\"fa fa-print mr-3\"></i> + 01 94060 37172</p>\r\n\r\n      </div>\r\n      <!-- Grid column -->\r\n\r\n    </div>\r\n    <!-- Grid row -->\r\n\r\n  </div>\r\n  <!-- Footer Links -->\r\n\r\n  <!-- Copyright -->\r\n  <div class=\"footer-copyright text-center py-3 footer-last-section\">© 2020 Copyright:\r\n    <a class=\"dark-grey-text\" href=\"https://curiositydesk\">CuriosityDesk</a>\r\n  </div>\r\n  <!-- Copyright -->\r\n\r\n</footer>\r\n<!-- Footer -->");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/modules/share/header/header-icon/header-icon.component.html":
/*!*******************************************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/modules/share/header/header-icon/header-icon.component.html ***!
  \*******************************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<div class=\"logo float-left\">\r\n    <a href=\"#intro\" class=\"scrollto\"><img src=\"../../assets/img/logo.png\" alt=\"\" class=\"img-fluid\"></a>\r\n </div>\r\n");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/modules/share/header/header-menu/header-menu.component.html":
/*!*******************************************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/modules/share/header/header-menu/header-menu.component.html ***!
  \*******************************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<nav class=\"navbar navbar-expand-lg  navbar-dark bg-dark\">\r\n\t<div class=\"container\">\r\n\t\t<a class=\"navbar-brand\" routerLink=\"/\">St.Francis English Medium School</a>\r\n\t\t<button class=\"navbar-toggler\" type=\"button\" data-toggle=\"collapse\" data-target=\"#navbarSupportedContent\"\r\n\t\t\taria-controls=\"navbarSupportedContent\" aria-expanded=\"false\" aria-label=\"Toggle navigation\">\r\n\t\t\t<span class=\"navbar-toggler-icon\"></span>\r\n\t\t</button>\r\n\r\n\t\t<div class=\"collapse navbar-collapse\" id=\"navbarSupportedContent\">\r\n\t\t\t<ul class=\"navbar-nav mr-auto\" *ngFor=\"let menu of menuList\">\r\n\t\t\t\t<li class=\"nav-item dropdown\">\r\n\t\t\t\t\t<a class=\"nav-link\" (click)=\"navigatePage(menu)\" *ngIf=\"menu?.child.length == 0\">{{menu.title}}</a>\r\n\t\t\t\t\t<a class=\"nav-link dropdown-toggle\" data-toggle=\"dropdown\" href=\"#\" role=\"button\"\r\n\t\t\t\t\t\taria-haspopup=\"true\" aria-expanded=\"false\" *ngIf=\"menu?.child.length\">\r\n\t\t\t\t\t\t<span>{{menu.title}}</span>\r\n\t\t\t\t\t</a>\r\n\t\t\t\t\t<div class=\"dropdown-menu\" aria-labelledby=\"navbarDropdownMenuLink\"\r\n\t\t\t\t\t\t*ngIf=\"menu?.child.length\">\r\n\t\t\t\t\t\t<span *ngFor=\"let sub_menu of menu.child \">\r\n\t\t\t\t\t\t\t<a class=\"dropdown-item\" (click)=\"navigatePage(sub_menu)\"> {{sub_menu.title}}</a>\r\n\t\t\t\t\t\t</span>\r\n\t\t\t\t\t</div>\r\n\r\n\t\t\t\t</li>\r\n\t\t\t</ul>\r\n\t\t</div>\r\n\t</div>\r\n</nav>\r\n");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/modules/share/header/header.component.html":
/*!**************************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/modules/share/header/header.component.html ***!
  \**************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<header id=\"header\" class=\"fixed-top\">\r\n  <div class=\"\">\r\n    <!-- <app-header-icon></app-header-icon> -->\r\n    <app-header-menu></app-header-menu>\r\n  </div>\r\n</header>\r\n");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/modules/share/loader/loader.component.html":
/*!**************************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/modules/share/loader/loader.component.html ***!
  \**************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<div id=\"showLoader\" class=\"text-center\">\r\n  <div class=\"loader\">\r\n    <div class=\"loaderWhiteBg\">\r\n      <div class=\"loaderSpinner\"></div>\r\n    </div>\r\n  </div>\r\n</div>\r\n");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/modules/share/sub-menu/sub-menu.component.html":
/*!******************************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/modules/share/sub-menu/sub-menu.component.html ***!
  \******************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<p>sub-menu works!</p>\r\n");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/modules/share/top-menu/top-menu.component.html":
/*!******************************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/modules/share/top-menu/top-menu.component.html ***!
  \******************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<p>top-menu works!</p>\r\n");

/***/ }),

/***/ "./node_modules/tslib/tslib.es6.js":
/*!*****************************************!*\
  !*** ./node_modules/tslib/tslib.es6.js ***!
  \*****************************************/
/*! exports provided: __extends, __assign, __rest, __decorate, __param, __metadata, __awaiter, __generator, __exportStar, __values, __read, __spread, __spreadArrays, __await, __asyncGenerator, __asyncDelegator, __asyncValues, __makeTemplateObject, __importStar, __importDefault */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__extends", function() { return __extends; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__assign", function() { return __assign; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__rest", function() { return __rest; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__decorate", function() { return __decorate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__param", function() { return __param; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__metadata", function() { return __metadata; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__awaiter", function() { return __awaiter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__generator", function() { return __generator; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__exportStar", function() { return __exportStar; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__values", function() { return __values; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__read", function() { return __read; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__spread", function() { return __spread; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__spreadArrays", function() { return __spreadArrays; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__await", function() { return __await; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__asyncGenerator", function() { return __asyncGenerator; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__asyncDelegator", function() { return __asyncDelegator; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__asyncValues", function() { return __asyncValues; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__makeTemplateObject", function() { return __makeTemplateObject; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__importStar", function() { return __importStar; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__importDefault", function() { return __importDefault; });
/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    }
    return __assign.apply(this, arguments);
}

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}

function __param(paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
}

function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}

function __awaiter(thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

function __exportStar(m, exports) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}

function __values(o) {
    var m = typeof Symbol === "function" && o[Symbol.iterator], i = 0;
    if (m) return m.call(o);
    return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
}

function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
}

function __spread() {
    for (var ar = [], i = 0; i < arguments.length; i++)
        ar = ar.concat(__read(arguments[i]));
    return ar;
}

function __spreadArrays() {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};

function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}

function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i;
    function verb(n) { if (g[n]) i[n] = function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]) > 1 || resume(n, v); }); }; }
    function resume(n, v) { try { step(g[n](v)); } catch (e) { settle(q[0][3], e); } }
    function step(r) { r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r); }
    function fulfill(value) { resume("next", value); }
    function reject(value) { resume("throw", value); }
    function settle(f, v) { if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]); }
}

function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function (e) { throw e; }), verb("return"), i[Symbol.iterator] = function () { return this; }, i;
    function verb(n, f) { i[n] = o[n] ? function (v) { return (p = !p) ? { value: __await(o[n](v)), done: n === "return" } : f ? f(v) : v; } : f; }
}

function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
    function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
    function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
}

function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};

function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result.default = mod;
    return result;
}

function __importDefault(mod) {
    return (mod && mod.__esModule) ? mod : { default: mod };
}


/***/ }),

/***/ "./src/app/app-routing.module.ts":
/*!***************************************!*\
  !*** ./src/app/app-routing.module.ts ***!
  \***************************************/
/*! exports provided: AppRoutingModule */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AppRoutingModule", function() { return AppRoutingModule; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/router */ "./node_modules/@angular/router/fesm2015/router.js");
/* harmony import */ var _app_modules_core_landing_page_landing_page_component__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../app/modules/core/landing-page/landing-page.component */ "./src/app/modules/core/landing-page/landing-page.component.ts");
/* harmony import */ var _app_modules_core_content_page_content_page_component__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../app/modules/core/content-page/content-page.component */ "./src/app/modules/core/content-page/content-page.component.ts");
/* harmony import */ var _app_modules_core_event_detail_event_detail_component__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../app/modules/core/event-detail/event-detail.component */ "./src/app/modules/core/event-detail/event-detail.component.ts");






const routes = [
    { path: '', component: _app_modules_core_landing_page_landing_page_component__WEBPACK_IMPORTED_MODULE_3__["LandingPageComponent"] },
    { path: ':slug', component: _app_modules_core_content_page_content_page_component__WEBPACK_IMPORTED_MODULE_4__["ContentPageComponent"] },
    { path: 'event/:slug', component: _app_modules_core_event_detail_event_detail_component__WEBPACK_IMPORTED_MODULE_5__["EventDetailComponent"] },
];
let AppRoutingModule = class AppRoutingModule {
};
AppRoutingModule = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["NgModule"])({
        imports: [_angular_router__WEBPACK_IMPORTED_MODULE_2__["RouterModule"].forRoot(routes, { useHash: true })],
        exports: [_angular_router__WEBPACK_IMPORTED_MODULE_2__["RouterModule"]]
    })
], AppRoutingModule);



/***/ }),

/***/ "./src/app/app.component.scss":
/*!************************************!*\
  !*** ./src/app/app.component.scss ***!
  \************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IiIsImZpbGUiOiJzcmMvYXBwL2FwcC5jb21wb25lbnQuc2NzcyJ9 */");

/***/ }),

/***/ "./src/app/app.component.ts":
/*!**********************************!*\
  !*** ./src/app/app.component.ts ***!
  \**********************************/
/*! exports provided: AppComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AppComponent", function() { return AppComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _app_service_core_service__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../app/service/core.service */ "./src/app/service/core.service.ts");



let AppComponent = class AppComponent {
    constructor(coreService) {
        this.coreService = coreService;
        this.title = 'st-francis-school-frontend';
        this.menuList = [
            {
                "slug": "a",
                "link": "",
                "id": 1,
                "title": "Abous Us",
                "child": [
                    {
                        "slug": "history",
                        "group_id": 1,
                        "id": 1,
                        "title": "History"
                    },
                    {
                        "slug": "vision",
                        "group_id": 1,
                        "id": 2,
                        "title": "Vision"
                    },
                    {
                        "slug": "mission",
                        "group_id": 1,
                        "id": 3,
                        "title": "Mission"
                    },
                    {
                        "slug": "principalmessage",
                        "group_id": 1,
                        "id": 4,
                        "title": "Principal’s Message"
                    },
                    // {
                    //   "slug": "head-mistresss-message",
                    //   "group_id": 1,
                    //   "id": 5,
                    //   "title": "Head Mistress’s Message"
                    // },
                    {
                        "slug": "faculty-staff-images",
                        "group_id": 1,
                        "id": 6,
                        "title": "Faculty – Staff Images"
                    }
                ]
            },
            {
                "slug": "i",
                "link": "",
                "id": 2,
                "title": "Institution",
                "child": [
                    {
                        "slug": "infrastructure",
                        "group_id": 2,
                        "id": 7,
                        "title": "Infrastructure"
                    },
                    {
                        "slug": "classroom",
                        "group_id": 2,
                        "id": 8,
                        "title": "Classroom"
                    },
                    {
                        "slug": "library",
                        "group_id": 2,
                        "id": 9,
                        "title": "Library"
                    },
                    {
                        "slug": "computer-lab",
                        "group_id": 2,
                        "id": 10,
                        "title": "Computer lab"
                    },
                    {
                        "slug": "playground",
                        "group_id": 2,
                        "id": 11,
                        "title": "Playground"
                    },
                    {
                        "slug": "medical-room",
                        "group_id": 2,
                        "id": 12,
                        "title": "Medical Room"
                    },
                    {
                        "slug": "art-craft",
                        "group_id": 2,
                        "id": 13,
                        "title": "Art & Craft"
                    },
                    {
                        "slug": "teaching-methods",
                        "group_id": 2,
                        "id": 14,
                        "title": "Teaching Methods"
                    },
                    {
                        "slug": "staff-room",
                        "group_id": 2,
                        "id": 15,
                        "title": "Staff Room"
                    },
                    {
                        "slug": "physical-education",
                        "group_id": 2,
                        "id": 16,
                        "title": "Physical Education"
                    },
                    {
                        "slug": "display-board",
                        "group_id": 2,
                        "id": 17,
                        "title": "Display Board"
                    },
                    {
                        "slug": "inclusion-of-value-education",
                        "group_id": 2,
                        "id": 18,
                        "title": "Inclusion of Value Education"
                    },
                    {
                        "slug": "music-dance",
                        "group_id": 2,
                        "id": 19,
                        "title": "Music & Dance"
                    },
                    {
                        "slug": "co-curricular-activities",
                        "group_id": 2,
                        "id": 20,
                        "title": "Co-Curricular Activities"
                    },
                    {
                        "slug": "club-house-system",
                        "group_id": 2,
                        "id": 21,
                        "title": "Club House System"
                    },
                    {
                        "slug": "assembly-conduction",
                        "group_id": 2,
                        "id": 22,
                        "title": "Assembly Conduction"
                    }
                ]
            },
            {
                "slug": "admission",
                "link": "admission",
                "id": 3,
                "title": "Admission",
                "child": [
                    {
                        "slug": "test",
                        "group_id": 3,
                        "id": 23,
                        "title": "Test"
                    }
                ]
            },
            // {
            //   "slug": "academics",
            //   "link": "academics",
            //   "id": 3,
            //   "title": "Academics",
            //   "child": [
            //     {
            //       "slug": "admission",
            //       "group_id": 3,
            //       "id": 1001,
            //       "title": "Admission"
            //     },
            //     {
            //       "slug": "fee-structure",
            //       "group_id": 3,
            //       "id": 1002,
            //       "title": "Fee Structure"
            //     },
            //     {
            //       "slug": "school-song",
            //       "group_id": 3,
            //       "id": 1003,
            //       "title": "School Song"
            //     },
            //     {
            //       "slug": "school-timing",
            //       "group_id": 3,
            //       "id": 1004,
            //       "title": "School Timing"
            //     },
            //   ]
            // },
            {
                "slug": "parents-zone",
                "link": "parents-zone",
                "id": 4,
                "title": "Parents Zone",
                "child": []
            },
            {
                "slug": "topper-images",
                "link": "topper-images",
                "id": 5,
                "title": "Topper Images",
                "child": []
            },
            {
                "slug": "gallery",
                "link": "gallery",
                "id": 6,
                "title": "Gallery",
                "child": []
            },
            {
                "slug": "contact-us",
                "link": "contact-us",
                "id": 7,
                "title": "Contact Us",
                "child": []
            }
        ];
    }
    OnInit() {
    }
};
AppComponent.ctorParameters = () => [
    { type: _app_service_core_service__WEBPACK_IMPORTED_MODULE_2__["CoreService"] }
];
AppComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: 'app-root',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./app.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/app.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./app.component.scss */ "./src/app/app.component.scss")).default]
    })
], AppComponent);



/***/ }),

/***/ "./src/app/app.module.ts":
/*!*******************************!*\
  !*** ./src/app/app.module.ts ***!
  \*******************************/
/*! exports provided: AppModule */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AppModule", function() { return AppModule; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_platform_browser__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/platform-browser */ "./node_modules/@angular/platform-browser/fesm2015/platform-browser.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_common_http__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @angular/common/http */ "./node_modules/@angular/common/fesm2015/http.js");
/* harmony import */ var _app_routing_module__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./app-routing.module */ "./src/app/app-routing.module.ts");
/* harmony import */ var _app_component__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./app.component */ "./src/app/app.component.ts");
/* harmony import */ var _app_modules_core_core_module__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../app/modules/core/core.module */ "./src/app/modules/core/core.module.ts");
/* harmony import */ var _app_modules_share_share_module__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../app/modules/share/share.module */ "./src/app/modules/share/share.module.ts");
/* harmony import */ var ngx_lightbox__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ngx-lightbox */ "./node_modules/ngx-lightbox/index.js");
/* harmony import */ var ngx_lightbox__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(ngx_lightbox__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _angular_common__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! @angular/common */ "./node_modules/@angular/common/fesm2015/common.js");










let AppModule = class AppModule {
};
AppModule = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_2__["NgModule"])({
        declarations: [
            _app_component__WEBPACK_IMPORTED_MODULE_5__["AppComponent"],
        ],
        imports: [
            _angular_platform_browser__WEBPACK_IMPORTED_MODULE_1__["BrowserModule"],
            _app_routing_module__WEBPACK_IMPORTED_MODULE_4__["AppRoutingModule"],
            _angular_common_http__WEBPACK_IMPORTED_MODULE_3__["HttpClientModule"],
            _app_modules_core_core_module__WEBPACK_IMPORTED_MODULE_6__["CoreModule"],
            _app_modules_share_share_module__WEBPACK_IMPORTED_MODULE_7__["ShareModule"],
            ngx_lightbox__WEBPACK_IMPORTED_MODULE_8__["LightboxModule"]
        ],
        providers: [{ provide: _angular_common__WEBPACK_IMPORTED_MODULE_9__["LocationStrategy"], useClass: _angular_common__WEBPACK_IMPORTED_MODULE_9__["HashLocationStrategy"] }],
        bootstrap: [_app_component__WEBPACK_IMPORTED_MODULE_5__["AppComponent"]]
    })
], AppModule);



/***/ }),

/***/ "./src/app/modules/core/contact-us/contact-us.component.scss":
/*!*******************************************************************!*\
  !*** ./src/app/modules/core/contact-us/contact-us.component.scss ***!
  \*******************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IiIsImZpbGUiOiJzcmMvYXBwL21vZHVsZXMvY29yZS9jb250YWN0LXVzL2NvbnRhY3QtdXMuY29tcG9uZW50LnNjc3MifQ== */");

/***/ }),

/***/ "./src/app/modules/core/contact-us/contact-us.component.ts":
/*!*****************************************************************!*\
  !*** ./src/app/modules/core/contact-us/contact-us.component.ts ***!
  \*****************************************************************/
/*! exports provided: ContactUsComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ContactUsComponent", function() { return ContactUsComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");


let ContactUsComponent = class ContactUsComponent {
    constructor() { }
    ngOnInit() {
    }
};
ContactUsComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: 'app-contact-us',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./contact-us.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/modules/core/contact-us/contact-us.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./contact-us.component.scss */ "./src/app/modules/core/contact-us/contact-us.component.scss")).default]
    })
], ContactUsComponent);



/***/ }),

/***/ "./src/app/modules/core/content-page/content-page.component.scss":
/*!***********************************************************************!*\
  !*** ./src/app/modules/core/content-page/content-page.component.scss ***!
  \***********************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("* {\n  box-sizing: border-box;\n}\n\n.image {\n  width: 20rem;\n  height: 20rem;\n  margin-bottom: 10px;\n}\n\n.overlay {\n  position: absolute;\n  bottom: 0;\n  background: black;\n  background: rgba(0, 0, 0, 0.5);\n  /* Black see-through */\n  color: #f1f1f1;\n  width: 100%;\n  transition: 0.5s ease;\n  opacity: 0;\n  color: white;\n  font-size: 20px;\n  padding: 20px;\n  text-align: center;\n}\n\n.image-container:hover .overlay {\n  opacity: 1;\n}\n\nul {\n  margin: 0;\n  padding: 0;\n  list-style: none;\n}\n\n.heading.heading-icon {\n  display: block;\n}\n\n.padding-lg {\n  display: block;\n  padding-top: 60px;\n  padding-bottom: 60px;\n}\n\n.practice-area.padding-lg {\n  padding-bottom: 55px;\n  padding-top: 55px;\n}\n\n.practice-area .inner {\n  border: 1px solid #999999;\n  text-align: center;\n  margin-bottom: 28px;\n  padding: 40px 25px;\n}\n\n.our-webcoderskull .cnt-block:hover {\n  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.3);\n  border: 0;\n}\n\n.practice-area .inner h3 {\n  color: #3c3c3c;\n  font-size: 24px;\n  font-weight: 500;\n  font-family: \"Poppins\", sans-serif;\n  padding: 10px 0;\n}\n\n.practice-area .inner p {\n  font-size: 14px;\n  line-height: 22px;\n  font-weight: 400;\n}\n\n.practice-area .inner img {\n  display: inline-block;\n}\n\n.our-webcoderskull .cnt-block {\n  float: left;\n  width: 100%;\n  background: #fff;\n  padding: 30px 20px;\n  text-align: center;\n  border: 2px solid #d5d5d5;\n  margin: 0 0 28px;\n}\n\n.our-webcoderskull .cnt-block figure {\n  width: 148px;\n  height: 148px;\n  border-radius: 100%;\n  display: inline-block;\n  margin-bottom: 15px;\n}\n\n.our-webcoderskull .cnt-block img {\n  width: 148px;\n  height: 148px;\n  border-radius: 100%;\n}\n\n.our-webcoderskull .cnt-block h3 {\n  color: #2a2a2a;\n  font-size: 20px;\n  font-weight: 500;\n  padding: 6px 0;\n}\n\n.our-webcoderskull .cnt-block h3 a {\n  text-decoration: none;\n  color: #2a2a2a;\n}\n\n.our-webcoderskull .cnt-block h3 a:hover {\n  color: #337ab7;\n}\n\n.our-webcoderskull .cnt-block p {\n  color: #2a2a2a;\n  font-size: 13px;\n  line-height: 20px;\n  font-weight: 400;\n}\n\n.our-webcoderskull .cnt-block .follow-us {\n  margin: 20px 0 0;\n}\n\n.our-webcoderskull .cnt-block .follow-us li {\n  display: inline-block;\n  width: auto;\n  margin: 0 5px;\n}\n\n.our-webcoderskull .cnt-block .follow-us li .fa {\n  font-size: 24px;\n  color: #767676;\n}\n\n.our-webcoderskull .cnt-block .follow-us li .fa:hover {\n  color: #025a8e;\n}\n\n.se-img-w-h {\n  width: 50rem !important;\n  height: 25rem !important;\n}\n\n.break-word {\n  white-space: pre-line;\n  text-align: justify;\n}\n\n.mb-25 {\n  margin-bottom: 25px;\n}\n\n.font-color {\n  color: #016991;\n}\n\n.mt-10 {\n  margin-top: 10px;\n}\n\n.address-section {\n  background-color: #f7f7f7;\n  padding: 10px;\n}\n\n.margin-up {\n  margin: 10px 0px 15px 0px;\n}\n\n.gallery-img {\n  width: 250px;\n  height: 300px;\n}\n\n.huge-margin-top {\n  margin-top: 100vh;\n}\n\n.img-row {\n  display: inline-block;\n}\n\n.img-frame {\n  margin: 10px;\n  border: 5px solid #fff;\n  cursor: pointer;\n  transition-duration: 0.3s;\n  transition-property: transform;\n}\n\n.img-frame:hover, .img-frame:focus, .img-frame:active {\n  transform: translateY(-5px);\n}\n\n.img-width {\n  width: 15rem;\n  height: 12rem;\n}\n\n.mouse {\n  cursor: pointer;\n}\n/*# sourceMappingURL=data:application/json;base64,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 */");

/***/ }),

/***/ "./src/app/modules/core/content-page/content-page.component.ts":
/*!*********************************************************************!*\
  !*** ./src/app/modules/core/content-page/content-page.component.ts ***!
  \*********************************************************************/
/*! exports provided: ContentPageComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ContentPageComponent", function() { return ContentPageComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/router */ "./node_modules/@angular/router/fesm2015/router.js");
/* harmony import */ var _app_service_core_service__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../../../app/service/core.service */ "./src/app/service/core.service.ts");
/* harmony import */ var _angular_platform_browser__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @angular/platform-browser */ "./node_modules/@angular/platform-browser/fesm2015/platform-browser.js");
/* harmony import */ var ngx_lightbox__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ngx-lightbox */ "./node_modules/ngx-lightbox/index.js");
/* harmony import */ var ngx_lightbox__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(ngx_lightbox__WEBPACK_IMPORTED_MODULE_5__);






let ContentPageComponent = class ContentPageComponent {
    constructor(route, coreService, titleService, _lightbox) {
        this.route = route;
        this.coreService = coreService;
        this.titleService = titleService;
        this._lightbox = _lightbox;
        this.showloader = true;
        this._album = [];
        this.facultyData = [];
        this.departmentData = [];
    }
    ngOnInit() {
        this.showloader = false;
        const sub = this.route.params.subscribe(params => {
            this.pageSlug = params.slug; // (+) converts string 'id' to a number
            console.log(this.pageSlug);
            if (this.pageSlug != undefined && this.pageSlug != null) {
                this.getPageContent(this.pageSlug);
            }
            if (this.pageSlug == 'faculty-staff-images' || this.pageSlug == 'administrative-departmente02bfce4-016a-4902-90e1-c2a1e323db98') {
                this.getDepartment();
            }
            // if(this.pageSlug == 'administrative-departmente02bfce4-016a-4902-90e1-c2a1e323db98'){
            //   this.getFaculty(4);
            // }
        });
    }
    getPageContent(slug) {
        // this.allContentData.forEach(element => {
        //   if(element.slug == this.pageSlug){
        //     this.contentData = element;
        //     this.titleService.setTitle( this.contentData.title + ' | St Francis English School' );
        //   }
        // });
        this.showloader = true;
        this.coreService.getPageContent(slug).subscribe(res => {
            console.log(res);
            let contentData = res[0];
            this.showloader = false;
            if (contentData.media && contentData.media.length) {
                contentData.media.forEach(element => {
                    let media_path = element.media_file.substr((element.media_file.lastIndexOf('media/')));
                    element.media_file = media_path;
                    console.log('element.media_file', element.media_file);
                    element.file_type = element.media_file.substr((element.media_file.lastIndexOf('.') + 1));
                    if (element.file_type.toLowerCase() == 'jpg' || element.file_type.toLowerCase() == 'png' || element.file_type.toLowerCase() == 'jpeg') {
                        element.show_img = true;
                    }
                    else {
                        element.show_img = false;
                    }
                });
            }
            this.contentData = contentData;
            console.log(this.contentData);
            // this.titleService.setTitle( this.contentData.title + ' | St Francis English School' );
        }, err => {
            console.log(err);
        });
    }
    open(index) {
        // open lightbox
        let image = [];
        this.contentData.media.forEach(element => {
            element.src = element.media_file.slice(30);
            image.push(element);
        });
        console.log(index);
        console.log();
        this._lightbox.open(image, index);
    }
    close() {
        // close lightbox programmatically
        this._lightbox.close();
    }
    download() {
        // http://localhost:4200/
        // http://stfrancisschoolkorba.ac.in
        var url = 'http://stfrancisschoolkorba.ac.in/assets/img/scool-events.docx';
        window.open(url, "_blank");
    }
    downloadFile(url) {
        window.open(url, "_blank");
    }
    getDepartment() {
        this.coreService.getDepartment().subscribe(res => {
            this.departmentData = res;
            this.getFaculty();
            console.log(res);
        }, err => {
            console.log(err);
        });
    }
    getFaculty() {
        this.coreService.getFaculty().subscribe(res => {
            if (res && res.length) {
                res.forEach((element, key) => {
                    this.departmentData.forEach((element2, key2) => {
                        if (element.department == element2.id) {
                            res[key].department_name = element2.title;
                            let media_path = element.profile_image ? element.profile_image.substr((element.profile_image.lastIndexOf('media/'))) : null;
                            element.profile_image = media_path;
                        }
                    });
                });
            }
            if (this.pageSlug == 'faculty-staff-images') {
                this.facultyData = res.filter(item => item.department_name != 'Administrative Department');
            }
            else {
                this.facultyData = res.filter(item => item.department_name == 'Administrative Department');
            }
            console.log(this.facultyData);
        }, err => {
            console.log(err);
        });
    }
};
ContentPageComponent.ctorParameters = () => [
    { type: _angular_router__WEBPACK_IMPORTED_MODULE_2__["ActivatedRoute"] },
    { type: _app_service_core_service__WEBPACK_IMPORTED_MODULE_3__["CoreService"] },
    { type: _angular_platform_browser__WEBPACK_IMPORTED_MODULE_4__["Title"] },
    { type: ngx_lightbox__WEBPACK_IMPORTED_MODULE_5__["Lightbox"] }
];
ContentPageComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: 'app-content-page',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./content-page.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/modules/core/content-page/content-page.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./content-page.component.scss */ "./src/app/modules/core/content-page/content-page.component.scss")).default]
    })
], ContentPageComponent);



/***/ }),

/***/ "./src/app/modules/core/core.module.ts":
/*!*********************************************!*\
  !*** ./src/app/modules/core/core.module.ts ***!
  \*********************************************/
/*! exports provided: CoreModule */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CoreModule", function() { return CoreModule; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_common__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/common */ "./node_modules/@angular/common/fesm2015/common.js");
/* harmony import */ var _content_page_content_page_component__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./content-page/content-page.component */ "./src/app/modules/core/content-page/content-page.component.ts");
/* harmony import */ var _contact_us_contact_us_component__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./contact-us/contact-us.component */ "./src/app/modules/core/contact-us/contact-us.component.ts");
/* harmony import */ var _faculty_faculty_component__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./faculty/faculty.component */ "./src/app/modules/core/faculty/faculty.component.ts");
/* harmony import */ var _event_event_component__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./event/event.component */ "./src/app/modules/core/event/event.component.ts");
/* harmony import */ var _landing_page_landing_page_component__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ./landing-page/landing-page.component */ "./src/app/modules/core/landing-page/landing-page.component.ts");
/* harmony import */ var _app_routing_module__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../../app-routing.module */ "./src/app/app-routing.module.ts");
/* harmony import */ var _share_share_module__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../share/share.module */ "./src/app/modules/share/share.module.ts");
/* harmony import */ var _page_container_page_container_component__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ./page-container/page-container.component */ "./src/app/modules/core/page-container/page-container.component.ts");
/* harmony import */ var _event_detail_event_detail_component__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ./event-detail/event-detail.component */ "./src/app/modules/core/event-detail/event-detail.component.ts");












let CoreModule = class CoreModule {
};
CoreModule = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["NgModule"])({
        declarations: [_content_page_content_page_component__WEBPACK_IMPORTED_MODULE_3__["ContentPageComponent"], _contact_us_contact_us_component__WEBPACK_IMPORTED_MODULE_4__["ContactUsComponent"], _faculty_faculty_component__WEBPACK_IMPORTED_MODULE_5__["FacultyComponent"], _event_event_component__WEBPACK_IMPORTED_MODULE_6__["EventComponent"], _landing_page_landing_page_component__WEBPACK_IMPORTED_MODULE_7__["LandingPageComponent"], _page_container_page_container_component__WEBPACK_IMPORTED_MODULE_10__["PageContainerComponent"], _event_detail_event_detail_component__WEBPACK_IMPORTED_MODULE_11__["EventDetailComponent"]],
        imports: [
            _angular_common__WEBPACK_IMPORTED_MODULE_2__["CommonModule"],
            _app_routing_module__WEBPACK_IMPORTED_MODULE_8__["AppRoutingModule"],
            _share_share_module__WEBPACK_IMPORTED_MODULE_9__["ShareModule"]
        ],
        exports: [
            _content_page_content_page_component__WEBPACK_IMPORTED_MODULE_3__["ContentPageComponent"], _contact_us_contact_us_component__WEBPACK_IMPORTED_MODULE_4__["ContactUsComponent"], _faculty_faculty_component__WEBPACK_IMPORTED_MODULE_5__["FacultyComponent"], _event_event_component__WEBPACK_IMPORTED_MODULE_6__["EventComponent"], _landing_page_landing_page_component__WEBPACK_IMPORTED_MODULE_7__["LandingPageComponent"]
        ]
    })
], CoreModule);



/***/ }),

/***/ "./src/app/modules/core/event-detail/event-detail.component.scss":
/*!***********************************************************************!*\
  !*** ./src/app/modules/core/event-detail/event-detail.component.scss ***!
  \***********************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IiIsImZpbGUiOiJzcmMvYXBwL21vZHVsZXMvY29yZS9ldmVudC1kZXRhaWwvZXZlbnQtZGV0YWlsLmNvbXBvbmVudC5zY3NzIn0= */");

/***/ }),

/***/ "./src/app/modules/core/event-detail/event-detail.component.ts":
/*!*********************************************************************!*\
  !*** ./src/app/modules/core/event-detail/event-detail.component.ts ***!
  \*********************************************************************/
/*! exports provided: EventDetailComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "EventDetailComponent", function() { return EventDetailComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/router */ "./node_modules/@angular/router/fesm2015/router.js");
/* harmony import */ var src_app_service_core_service__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! src/app/service/core.service */ "./src/app/service/core.service.ts");
/* harmony import */ var ngx_lightbox__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ngx-lightbox */ "./node_modules/ngx-lightbox/index.js");
/* harmony import */ var ngx_lightbox__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(ngx_lightbox__WEBPACK_IMPORTED_MODULE_4__);





let EventDetailComponent = class EventDetailComponent {
    constructor(route, coreService, _lightbox) {
        this.route = route;
        this.coreService = coreService;
        this._lightbox = _lightbox;
        this.showloader = false;
    }
    ngOnInit() {
        this.id = this.route.snapshot.paramMap.get('slug');
        console.log(this.id);
        this.showloader = true;
        this.coreService.getEventDetail(this.id).subscribe(res => {
            this.showloader = false;
            this.contentData = res;
            console.log(this.contentData);
        }, error => {
            this.showloader = false;
            console.log(error);
        });
    }
    download() {
        // http://localhost:4200/
        // http://stfrancisschoolkorba.ac.in
        var url = 'http://stfrancisschoolkorba.ac.in/assets/img/scool-events.docx';
        window.open(url, "_blank");
    }
    downloadFile(url) {
        window.open(url, "_blank");
    }
    open(index) {
        // open lightbox
        let image = [];
        this.contentData.media.forEach(element => {
            element.src = element.media_file.slice(30);
            image.push(element);
        });
        console.log(index);
        console.log();
        this._lightbox.open(image, index);
    }
};
EventDetailComponent.ctorParameters = () => [
    { type: _angular_router__WEBPACK_IMPORTED_MODULE_2__["ActivatedRoute"] },
    { type: src_app_service_core_service__WEBPACK_IMPORTED_MODULE_3__["CoreService"] },
    { type: ngx_lightbox__WEBPACK_IMPORTED_MODULE_4__["Lightbox"] }
];
EventDetailComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: 'app-event-detail',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./event-detail.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/modules/core/event-detail/event-detail.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./event-detail.component.scss */ "./src/app/modules/core/event-detail/event-detail.component.scss")).default]
    })
], EventDetailComponent);



/***/ }),

/***/ "./src/app/modules/core/event/event.component.scss":
/*!*********************************************************!*\
  !*** ./src/app/modules/core/event/event.component.scss ***!
  \*********************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (".event-img {\n  padding: 5px;\n  height: 12rem !important;\n}\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInNyYy9hcHAvbW9kdWxlcy9jb3JlL2V2ZW50L0M6XFxkZXZlbG9wbWVudFxcc3QtZnJhbmNpcy1zY2hvb2xcXHN0LWZyYW5jaXMtc2Nob29sLWZyb250ZW5kL3NyY1xcYXBwXFxtb2R1bGVzXFxjb3JlXFxldmVudFxcZXZlbnQuY29tcG9uZW50LnNjc3MiLCJzcmMvYXBwL21vZHVsZXMvY29yZS9ldmVudC9ldmVudC5jb21wb25lbnQuc2NzcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQTtFQUNJLFlBQUE7RUFDQSx3QkFBQTtBQ0NKIiwiZmlsZSI6InNyYy9hcHAvbW9kdWxlcy9jb3JlL2V2ZW50L2V2ZW50LmNvbXBvbmVudC5zY3NzIiwic291cmNlc0NvbnRlbnQiOlsiLmV2ZW50LWltZ3tcclxuICAgIHBhZGRpbmc6IDVweDtcclxuICAgIGhlaWdodDogMTJyZW0gIWltcG9ydGFudDtcclxufSIsIi5ldmVudC1pbWcge1xuICBwYWRkaW5nOiA1cHg7XG4gIGhlaWdodDogMTJyZW0gIWltcG9ydGFudDtcbn0iXX0= */");

/***/ }),

/***/ "./src/app/modules/core/event/event.component.ts":
/*!*******************************************************!*\
  !*** ./src/app/modules/core/event/event.component.ts ***!
  \*******************************************************/
/*! exports provided: EventComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "EventComponent", function() { return EventComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/router */ "./node_modules/@angular/router/fesm2015/router.js");



let EventComponent = class EventComponent {
    constructor(router) {
        this.router = router;
        this.pageData = {};
    }
    ngOnInit() {
        this.pageData = this.events;
        // console.log(JSON.parse(JSON.stringify(this.pageData)));
    }
    viewDetailPage(data) {
        console.log(data);
        console.log('event-detail/' + data.slug);
        this.router.navigate(['event/' + data.slug]);
    }
};
EventComponent.ctorParameters = () => [
    { type: _angular_router__WEBPACK_IMPORTED_MODULE_2__["Router"] }
];
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Input"])()
], EventComponent.prototype, "events", void 0);
EventComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: 'app-event',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./event.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/modules/core/event/event.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./event.component.scss */ "./src/app/modules/core/event/event.component.scss")).default]
    })
], EventComponent);



/***/ }),

/***/ "./src/app/modules/core/faculty/faculty.component.scss":
/*!*************************************************************!*\
  !*** ./src/app/modules/core/faculty/faculty.component.scss ***!
  \*************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IiIsImZpbGUiOiJzcmMvYXBwL21vZHVsZXMvY29yZS9mYWN1bHR5L2ZhY3VsdHkuY29tcG9uZW50LnNjc3MifQ== */");

/***/ }),

/***/ "./src/app/modules/core/faculty/faculty.component.ts":
/*!***********************************************************!*\
  !*** ./src/app/modules/core/faculty/faculty.component.ts ***!
  \***********************************************************/
/*! exports provided: FacultyComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FacultyComponent", function() { return FacultyComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _app_service_core_service__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../../../app/service/core.service */ "./src/app/service/core.service.ts");



let FacultyComponent = class FacultyComponent {
    constructor(coreService) {
        this.coreService = coreService;
        this.facultyData = [];
    }
    ngOnInit() {
        this.getFaculty();
    }
    getFaculty() {
        this.coreService.getFaculty().subscribe(res => {
            this.facultyData = res;
            console.log(res);
        }, err => {
            console.log(err);
        });
    }
};
FacultyComponent.ctorParameters = () => [
    { type: _app_service_core_service__WEBPACK_IMPORTED_MODULE_2__["CoreService"] }
];
FacultyComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: 'app-faculty',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./faculty.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/modules/core/faculty/faculty.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./faculty.component.scss */ "./src/app/modules/core/faculty/faculty.component.scss")).default]
    })
], FacultyComponent);



/***/ }),

/***/ "./src/app/modules/core/landing-page/landing-page.component.scss":
/*!***********************************************************************!*\
  !*** ./src/app/modules/core/landing-page/landing-page.component.scss ***!
  \***********************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (".content ._mainImage ._image {\n  height: 26rem;\n  width: 100%;\n}\n\n.container-fluid {\n  padding-left: 0px !important;\n  padding-right: 0px !important;\n}\n\n.carousel-control-next {\n  right: -10%;\n}\n\n.carousel-control-prev {\n  left: -10%;\n}\n\n.carousel-control-next-icon,\n.carousel-control-prev-icon {\n  background-color: black;\n}\n\n.cta-100 {\n  padding-left: 8%;\n}\n\n.col-md-4 {\n  padding-bottom: 20px;\n}\n\n.white {\n  color: #fff !important;\n}\n\n.mt {\n  float: left;\n  margin-top: -20px;\n  padding-top: 20px;\n}\n\n.bg-blue-ui {\n  background-color: #708198 !important;\n}\n\nfigure img {\n  width: 300px;\n}\n\n#blogCarousel {\n  padding-bottom: 100px;\n}\n\n.blog .carousel-indicators {\n  left: 0;\n  top: -50px;\n  height: 50%;\n}\n\n/* The colour of the indicators */\n\n.blog .carousel-indicators li {\n  background: #708198;\n  border-radius: 50%;\n}\n\n.blog .carousel-indicators .active {\n  background: #0fc9af;\n}\n\n.item-carousel-blog-block {\n  outline: medium none;\n  padding: 15px;\n}\n\n.item-box-blog {\n  border: 1px solid #dadada;\n  text-align: center;\n  z-index: 4;\n  padding: 20px;\n  min-height: 270px;\n}\n\n.item-box-blog-image {\n  position: relative;\n}\n\n.item-box-blog-image figure img {\n  width: 100%;\n  height: auto;\n}\n\n.item-box-blog-date {\n  position: absolute;\n  z-index: 5;\n  padding: 4px 20px;\n  top: -20px;\n  right: 8px;\n  background-color: #41cb52;\n}\n\n.item-box-blog-date span {\n  color: #fff;\n  display: block;\n  text-align: center;\n  line-height: 1.2;\n}\n\n.item-box-blog-date span.mon {\n  font-size: 18px;\n}\n\n.item-box-blog-date span.day {\n  font-size: 16px;\n}\n\n.item-box-blog-body {\n  padding: 10px;\n}\n\n.item-heading-blog a h5 {\n  margin: 0;\n  line-height: 1;\n  text-decoration: none;\n  transition: color 0.3s;\n}\n\n.item-box-blog-heading a {\n  text-decoration: none;\n}\n\n.item-box-blog-data p {\n  font-size: 13px;\n}\n\n.item-box-blog-data p i {\n  font-size: 12px;\n}\n\n.item-box-blog-text {\n  overflow: hidden;\n}\n\n.mt-10 {\n  float: left;\n  margin-top: -10px;\n  padding-top: 10px;\n}\n\n.btn.bg-blue-ui.white.read {\n  cursor: pointer;\n  padding: 4px 20px;\n  float: left;\n  margin-top: 10px;\n}\n\n.btn.bg-blue-ui.white.read:hover {\n  box-shadow: 0px 5px 15px inset #4d5f77;\n}\n\n.text-css {\n  text-align: justify !important;\n  white-space: normal;\n}\n/*# sourceMappingURL=data:application/json;base64,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 */");

/***/ }),

/***/ "./src/app/modules/core/landing-page/landing-page.component.ts":
/*!*********************************************************************!*\
  !*** ./src/app/modules/core/landing-page/landing-page.component.ts ***!
  \*********************************************************************/
/*! exports provided: LandingPageComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "LandingPageComponent", function() { return LandingPageComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/router */ "./node_modules/@angular/router/fesm2015/router.js");
/* harmony import */ var _app_service_core_service__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../../../app/service/core.service */ "./src/app/service/core.service.ts");
/* harmony import */ var _angular_platform_browser__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @angular/platform-browser */ "./node_modules/@angular/platform-browser/fesm2015/platform-browser.js");





let LandingPageComponent = class LandingPageComponent {
    constructor(coreService, route, titleService) {
        this.coreService = coreService;
        this.route = route;
        this.titleService = titleService;
        this.contentData = [];
        this.showloader = true;
        this.eventDta = [];
        this.facultyData = [];
        this.pageData = [];
    }
    ngOnInit() {
        this.getAllPages();
        this.getEvent();
        this.titleService.setTitle('Home | St Francis English School');
        this.showloader = false;
    }
    getAllPages() {
        this.showloader = true;
        this.coreService.getAllPages().subscribe(res => {
            this.contentData = res;
            for (let i = 0; i < this.contentData.length; i++) {
                if (this.contentData[i].slug == 'history' || this.contentData[i].slug == 'vision' || this.contentData[i].slug == 'mission' || this.contentData[i].slug == 'principalmessage' || this.contentData[i].slug == 'headmistress') {
                    this.pageData.push(this.contentData[i]);
                    console.log(this.contentData[i].slug);
                }
                console.log(this.pageData);
                this.showloader = false;
            }
        }, err => {
            console.log(err);
            this.showloader = false;
        });
    }
    getEvent() {
        this.coreService.getEvent().subscribe(res => {
            this.eventDta = JSON.parse(JSON.stringify(res));
            console.log(this.eventDta);
        }, err => {
            console.log(err);
        });
    }
};
LandingPageComponent.ctorParameters = () => [
    { type: _app_service_core_service__WEBPACK_IMPORTED_MODULE_3__["CoreService"] },
    { type: _angular_router__WEBPACK_IMPORTED_MODULE_2__["ActivatedRoute"] },
    { type: _angular_platform_browser__WEBPACK_IMPORTED_MODULE_4__["Title"] }
];
LandingPageComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: 'app-landing-page',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./landing-page.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/modules/core/landing-page/landing-page.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./landing-page.component.scss */ "./src/app/modules/core/landing-page/landing-page.component.scss")).default]
    })
], LandingPageComponent);



/***/ }),

/***/ "./src/app/modules/core/page-container/page-container.component.scss":
/*!***************************************************************************!*\
  !*** ./src/app/modules/core/page-container/page-container.component.scss ***!
  \***************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (".card {\n  margin-bottom: 2rem;\n}\n\n.img-card-css {\n  width: 21rem !important;\n  height: 12rem !important;\n  padding: 0.6rem !important;\n}\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInNyYy9hcHAvbW9kdWxlcy9jb3JlL3BhZ2UtY29udGFpbmVyL0M6XFxkZXZlbG9wbWVudFxcc3QtZnJhbmNpcy1zY2hvb2xcXHN0LWZyYW5jaXMtc2Nob29sLWZyb250ZW5kL3NyY1xcYXBwXFxtb2R1bGVzXFxjb3JlXFxwYWdlLWNvbnRhaW5lclxccGFnZS1jb250YWluZXIuY29tcG9uZW50LnNjc3MiLCJzcmMvYXBwL21vZHVsZXMvY29yZS9wYWdlLWNvbnRhaW5lci9wYWdlLWNvbnRhaW5lci5jb21wb25lbnQuc2NzcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQTtFQUVFLG1CQUFBO0FDQUY7O0FER0E7RUFDRSx1QkFBQTtFQUNFLHdCQUFBO0VBQ0EsMEJBQUE7QUNBSiIsImZpbGUiOiJzcmMvYXBwL21vZHVsZXMvY29yZS9wYWdlLWNvbnRhaW5lci9wYWdlLWNvbnRhaW5lci5jb21wb25lbnQuc2NzcyIsInNvdXJjZXNDb250ZW50IjpbIi5jYXJke1xyXG4gIC8vIG1pbi1oZWlnaHQ6IDM1cmVtO1xyXG4gIG1hcmdpbi1ib3R0b206IDJyZW07XHJcbn1cclxuXHJcbi5pbWctY2FyZC1jc3N7XHJcbiAgd2lkdGg6IDIxcmVtICFpbXBvcnRhbnQ7XHJcbiAgICBoZWlnaHQ6IDEycmVtICFpbXBvcnRhbnQ7XHJcbiAgICBwYWRkaW5nOiAwLjZyZW0gIWltcG9ydGFudDtcclxufVxyXG4iLCIuY2FyZCB7XG4gIG1hcmdpbi1ib3R0b206IDJyZW07XG59XG5cbi5pbWctY2FyZC1jc3Mge1xuICB3aWR0aDogMjFyZW0gIWltcG9ydGFudDtcbiAgaGVpZ2h0OiAxMnJlbSAhaW1wb3J0YW50O1xuICBwYWRkaW5nOiAwLjZyZW0gIWltcG9ydGFudDtcbn0iXX0= */");

/***/ }),

/***/ "./src/app/modules/core/page-container/page-container.component.ts":
/*!*************************************************************************!*\
  !*** ./src/app/modules/core/page-container/page-container.component.ts ***!
  \*************************************************************************/
/*! exports provided: PageContainerComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PageContainerComponent", function() { return PageContainerComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");


let PageContainerComponent = class PageContainerComponent {
    constructor() {
    }
    ngOnInit() {
        this.pageData = this.data;
        // console.log(this.data);
    }
};
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Input"])()
], PageContainerComponent.prototype, "data", void 0);
PageContainerComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: 'app-page-container',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./page-container.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/modules/core/page-container/page-container.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./page-container.component.scss */ "./src/app/modules/core/page-container/page-container.component.scss")).default]
    })
], PageContainerComponent);



/***/ }),

/***/ "./src/app/modules/share/footer/footer.component.scss":
/*!************************************************************!*\
  !*** ./src/app/modules/share/footer/footer.component.scss ***!
  \************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IiIsImZpbGUiOiJzcmMvYXBwL21vZHVsZXMvc2hhcmUvZm9vdGVyL2Zvb3Rlci5jb21wb25lbnQuc2NzcyJ9 */");

/***/ }),

/***/ "./src/app/modules/share/footer/footer.component.ts":
/*!**********************************************************!*\
  !*** ./src/app/modules/share/footer/footer.component.ts ***!
  \**********************************************************/
/*! exports provided: FooterComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FooterComponent", function() { return FooterComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");


let FooterComponent = class FooterComponent {
    constructor() { }
    ngOnInit() {
    }
};
FooterComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: 'app-footer',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./footer.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/modules/share/footer/footer.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./footer.component.scss */ "./src/app/modules/share/footer/footer.component.scss")).default]
    })
], FooterComponent);



/***/ }),

/***/ "./src/app/modules/share/header/header-icon/header-icon.component.scss":
/*!*****************************************************************************!*\
  !*** ./src/app/modules/share/header/header-icon/header-icon.component.scss ***!
  \*****************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IiIsImZpbGUiOiJzcmMvYXBwL21vZHVsZXMvc2hhcmUvaGVhZGVyL2hlYWRlci1pY29uL2hlYWRlci1pY29uLmNvbXBvbmVudC5zY3NzIn0= */");

/***/ }),

/***/ "./src/app/modules/share/header/header-icon/header-icon.component.ts":
/*!***************************************************************************!*\
  !*** ./src/app/modules/share/header/header-icon/header-icon.component.ts ***!
  \***************************************************************************/
/*! exports provided: HeaderIconComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "HeaderIconComponent", function() { return HeaderIconComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");


let HeaderIconComponent = class HeaderIconComponent {
    constructor() { }
    ngOnInit() {
    }
};
HeaderIconComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: 'app-header-icon',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./header-icon.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/modules/share/header/header-icon/header-icon.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./header-icon.component.scss */ "./src/app/modules/share/header/header-icon/header-icon.component.scss")).default]
    })
], HeaderIconComponent);



/***/ }),

/***/ "./src/app/modules/share/header/header-menu/header-menu.component.scss":
/*!*****************************************************************************!*\
  !*** ./src/app/modules/share/header/header-menu/header-menu.component.scss ***!
  \*****************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("body {\n  margin: 0 3%;\n  background-color: #ccc;\n}\n\nnav {\n  white-space: nowrap;\n}\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInNyYy9hcHAvbW9kdWxlcy9zaGFyZS9oZWFkZXIvaGVhZGVyLW1lbnUvQzpcXGRldmVsb3BtZW50XFxzdC1mcmFuY2lzLXNjaG9vbFxcc3QtZnJhbmNpcy1zY2hvb2wtZnJvbnRlbmQvc3JjXFxhcHBcXG1vZHVsZXNcXHNoYXJlXFxoZWFkZXJcXGhlYWRlci1tZW51XFxoZWFkZXItbWVudS5jb21wb25lbnQuc2NzcyIsInNyYy9hcHAvbW9kdWxlcy9zaGFyZS9oZWFkZXIvaGVhZGVyLW1lbnUvaGVhZGVyLW1lbnUuY29tcG9uZW50LnNjc3MiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUE7RUFBTSxZQUFBO0VBQWEsc0JBQUE7QUNHbkI7O0FERkE7RUFBSyxtQkFBQTtBQ01MIiwiZmlsZSI6InNyYy9hcHAvbW9kdWxlcy9zaGFyZS9oZWFkZXIvaGVhZGVyLW1lbnUvaGVhZGVyLW1lbnUuY29tcG9uZW50LnNjc3MiLCJzb3VyY2VzQ29udGVudCI6WyJib2R5IHttYXJnaW46MCAzJTsgYmFja2dyb3VuZC1jb2xvcjojY2NjO31cclxubmF2IHt3aGl0ZS1zcGFjZTogbm93cmFwOyB9IiwiYm9keSB7XG4gIG1hcmdpbjogMCAzJTtcbiAgYmFja2dyb3VuZC1jb2xvcjogI2NjYztcbn1cblxubmF2IHtcbiAgd2hpdGUtc3BhY2U6IG5vd3JhcDtcbn0iXX0= */");

/***/ }),

/***/ "./src/app/modules/share/header/header-menu/header-menu.component.ts":
/*!***************************************************************************!*\
  !*** ./src/app/modules/share/header/header-menu/header-menu.component.ts ***!
  \***************************************************************************/
/*! exports provided: HeaderMenuComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "HeaderMenuComponent", function() { return HeaderMenuComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _app_service_core_service__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../../../../app/service/core.service */ "./src/app/service/core.service.ts");
/* harmony import */ var _angular_router__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @angular/router */ "./node_modules/@angular/router/fesm2015/router.js");




let HeaderMenuComponent = class HeaderMenuComponent {
    constructor(coreService, router) {
        this.coreService = coreService;
        this.router = router;
        this.menuList = [
        /* {
           "slug": "a",
           "link": "",
           "id": 1,
           "title": "Abous Us",
           "child": [
             {
               "slug": "history",
               "group_id": 1,
               "id": 1,
               "title": "History"
             },
             {
               "slug": "vision",
               "group_id": 1,
               "id": 2,
               "title": "Vision"
             },
             {
               "slug": "mission",
               "group_id": 1,
               "id": 3,
               "title": "Mission"
             },
             {
               "slug": "principalmessage",
               "group_id": 1,
               "id": 4,
               "title": "Principal’s Message"
             },
             {
               "slug": "faculty-staff-images",
               "group_id": 1,
               "id": 6,
               "title": "Faculty – Staff Images"
             }
           ]
         },
         {
           "slug": "i",
           "link": "",
           "id": 2,
           "title": "Institution",
           "child": [
             {
               "slug": "infrastructure",
               "group_id": 2,
               "id": 7,
               "title": "Infrastructure"
             },
             {
               "slug": "library",
               "group_id": 2,
               "id": 9,
               "title": "Library"
             },
             {
               "slug": "computer-lab",
               "group_id": 2,
               "id": 10,
               "title": "Computer lab"
             },
             {
               "slug": "playground",
               "group_id": 2,
               "id": 11,
               "title": "Playground"
             },
             {
               "slug": "art-craft",
               "group_id": 2,
               "id": 13,
               "title": "Art & Craft"
             },
             {
               "slug": "teaching-methods",
               "group_id": 2,
               "id": 14,
               "title": "Teaching Methods"
             },
             // {
             //   "slug": "staff-room",
             //   "group_id": 2,
             //   "id": 15,
             //   "title": "Staff Room"
             // },
             {
               "slug": "physical-education",
               "group_id": 2,
               "id": 16,
               "title": "Physical Education"
             },
             {
               "slug": "display-board",
               "group_id": 2,
               "id": 17,
               "title": "Display Board"
             },
             {
               "slug": "inclusion-of-value-education",
               "group_id": 2,
               "id": 18,
               "title": "Inclusion of Value Education"
             },
             {
               "slug": "music-dance",
               "group_id": 2,
               "id": 19,
               "title": "Music & Dance"
             },
             {
               "slug": "co-curricular-activities",
               "group_id": 2,
               "id": 20,
               "title": "Co-Curricular Activities"
             },
             {
               "slug": "club-house-system",
               "group_id": 2,
               "id": 21,
               "title": "Club House System"
             },
             {
               "slug": "assembly-conduction",
               "group_id": 2,
               "id": 22,
               "title": "Assembly Conduction"
             }
           ]
         },
         {
           "slug": "admission",
           "link": "admission",
           "id": 3,
           "title": "Admission",
           "child": []
         },
         // {
         //   "slug": "academics",
         //   "link": "academics",
         //   "id": 3,
         //   "title": "Academics",
         //   "child": [
         //     {
         //       "slug": "admission",
         //       "group_id": 3,
         //       "id": 1001,
         //       "title": "Admission"
         //     },
         //     {
         //       "slug": "fee-structure",
         //       "group_id": 3,
         //       "id": 1002,
         //       "title": "Fee Structure"
         //     },
         //     {
         //       "slug": "school-song",
         //       "group_id": 3,
         //       "id": 1003,
         //       "title": "School Song"
         //     },
         //     {
         //       "slug": "school-timing",
         //       "group_id": 3,
         //       "id": 1004,
         //       "title": "School Timing"
         //     },
         //   ]
         // },
         {
           "slug": "school-event",
           "link": "school-event",
           "id": 55,
           "title": "School Events",
           "child": []
         },
         {
           "slug": "gallery",
           "link": "gallery",
           "id": 6,
           "title": "Gallery",
           "child": []
         },
         {
           "slug": "contact-us",
           "link": "contact-us",
           "id": 7,
           "title": "Contact Us",
           "child": []
         }*/
        ];
        this.getMenu();
    }
    ngOnInit() {
    }
    getMenu() {
        console.log('called 1');
        this.coreService.getMenu().subscribe(res => {
            console.log(res);
            this.menuList = res;
        }, err => {
            console.log(err);
        });
    }
    navigatePage(data) {
        console.log(data);
        // if(data.link){
        //   this.router.navigate(['/'+data.link]);
        // }else{
        this.router.navigate(['/' + data.slug]);
        // }
    }
};
HeaderMenuComponent.ctorParameters = () => [
    { type: _app_service_core_service__WEBPACK_IMPORTED_MODULE_2__["CoreService"] },
    { type: _angular_router__WEBPACK_IMPORTED_MODULE_3__["Router"] }
];
HeaderMenuComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: 'app-header-menu',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./header-menu.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/modules/share/header/header-menu/header-menu.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./header-menu.component.scss */ "./src/app/modules/share/header/header-menu/header-menu.component.scss")).default]
    })
], HeaderMenuComponent);



/***/ }),

/***/ "./src/app/modules/share/header/header.component.scss":
/*!************************************************************!*\
  !*** ./src/app/modules/share/header/header.component.scss ***!
  \************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IiIsImZpbGUiOiJzcmMvYXBwL21vZHVsZXMvc2hhcmUvaGVhZGVyL2hlYWRlci5jb21wb25lbnQuc2NzcyJ9 */");

/***/ }),

/***/ "./src/app/modules/share/header/header.component.ts":
/*!**********************************************************!*\
  !*** ./src/app/modules/share/header/header.component.ts ***!
  \**********************************************************/
/*! exports provided: HeaderComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "HeaderComponent", function() { return HeaderComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");


let HeaderComponent = class HeaderComponent {
    constructor() { }
    ngOnInit() {
    }
};
HeaderComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: 'app-header',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./header.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/modules/share/header/header.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./header.component.scss */ "./src/app/modules/share/header/header.component.scss")).default]
    })
], HeaderComponent);



/***/ }),

/***/ "./src/app/modules/share/loader/loader.component.scss":
/*!************************************************************!*\
  !*** ./src/app/modules/share/loader/loader.component.scss ***!
  \************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (".loader {\n  background-color: #fff;\n  position: fixed;\n  top: 55px;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  z-index: 9999;\n}\n\n.loaderWhiteBg {\n  top: 40%;\n  left: 45%;\n  position: absolute;\n  color: #fff;\n  border-radius: 10px;\n}\n\n.loaderSpinner {\n  border: 10px solid #f3f3f3;\n  border-radius: 50%;\n  border-top: 10px solid #016991;\n  width: 120px;\n  height: 120px;\n  -webkit-animation: spin 2s linear infinite;\n  /* Safari */\n  animation: spin 2s linear infinite;\n}\n\n/* Safari */\n\n@-webkit-keyframes spin {\n  0% {\n    -webkit-transform: rotate(0deg);\n  }\n  100% {\n    -webkit-transform: rotate(360deg);\n  }\n}\n\n@keyframes spin {\n  0% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n}\n/*# sourceMappingURL=data:application/json;base64,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 */");

/***/ }),

/***/ "./src/app/modules/share/loader/loader.component.ts":
/*!**********************************************************!*\
  !*** ./src/app/modules/share/loader/loader.component.ts ***!
  \**********************************************************/
/*! exports provided: LoaderComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "LoaderComponent", function() { return LoaderComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");


let LoaderComponent = class LoaderComponent {
    // @Input() showLoader: boolean = true;
    constructor() { }
    ngOnInit() {
    }
};
LoaderComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: 'app-loader',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./loader.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/modules/share/loader/loader.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./loader.component.scss */ "./src/app/modules/share/loader/loader.component.scss")).default]
    })
], LoaderComponent);



/***/ }),

/***/ "./src/app/modules/share/share.module.ts":
/*!***********************************************!*\
  !*** ./src/app/modules/share/share.module.ts ***!
  \***********************************************/
/*! exports provided: ShareModule */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ShareModule", function() { return ShareModule; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_common__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/common */ "./node_modules/@angular/common/fesm2015/common.js");
/* harmony import */ var _header_header_component__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./header/header.component */ "./src/app/modules/share/header/header.component.ts");
/* harmony import */ var _footer_footer_component__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./footer/footer.component */ "./src/app/modules/share/footer/footer.component.ts");
/* harmony import */ var _top_menu_top_menu_component__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./top-menu/top-menu.component */ "./src/app/modules/share/top-menu/top-menu.component.ts");
/* harmony import */ var _header_header_menu_header_menu_component__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./header/header-menu/header-menu.component */ "./src/app/modules/share/header/header-menu/header-menu.component.ts");
/* harmony import */ var _header_header_icon_header_icon_component__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ./header/header-icon/header-icon.component */ "./src/app/modules/share/header/header-icon/header-icon.component.ts");
/* harmony import */ var _sub_menu_sub_menu_component__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ./sub-menu/sub-menu.component */ "./src/app/modules/share/sub-menu/sub-menu.component.ts");
/* harmony import */ var _angular_router__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! @angular/router */ "./node_modules/@angular/router/fesm2015/router.js");
/* harmony import */ var _angular_platform_browser__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! @angular/platform-browser */ "./node_modules/@angular/platform-browser/fesm2015/platform-browser.js");
/* harmony import */ var _loader_loader_component__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ./loader/loader.component */ "./src/app/modules/share/loader/loader.component.ts");












let ShareModule = class ShareModule {
};
ShareModule = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["NgModule"])({
        declarations: [_header_header_component__WEBPACK_IMPORTED_MODULE_3__["HeaderComponent"], _footer_footer_component__WEBPACK_IMPORTED_MODULE_4__["FooterComponent"], _top_menu_top_menu_component__WEBPACK_IMPORTED_MODULE_5__["TopMenuComponent"], _header_header_menu_header_menu_component__WEBPACK_IMPORTED_MODULE_6__["HeaderMenuComponent"], _header_header_icon_header_icon_component__WEBPACK_IMPORTED_MODULE_7__["HeaderIconComponent"], _sub_menu_sub_menu_component__WEBPACK_IMPORTED_MODULE_8__["SubMenuComponent"], _loader_loader_component__WEBPACK_IMPORTED_MODULE_11__["LoaderComponent"]],
        imports: [
            _angular_common__WEBPACK_IMPORTED_MODULE_2__["CommonModule"],
            _angular_router__WEBPACK_IMPORTED_MODULE_9__["RouterModule"]
        ],
        providers: [
            _angular_platform_browser__WEBPACK_IMPORTED_MODULE_10__["Title"]
        ],
        exports: [_header_header_component__WEBPACK_IMPORTED_MODULE_3__["HeaderComponent"], _footer_footer_component__WEBPACK_IMPORTED_MODULE_4__["FooterComponent"], _top_menu_top_menu_component__WEBPACK_IMPORTED_MODULE_5__["TopMenuComponent"], _sub_menu_sub_menu_component__WEBPACK_IMPORTED_MODULE_8__["SubMenuComponent"], _loader_loader_component__WEBPACK_IMPORTED_MODULE_11__["LoaderComponent"]]
    })
], ShareModule);



/***/ }),

/***/ "./src/app/modules/share/sub-menu/sub-menu.component.scss":
/*!****************************************************************!*\
  !*** ./src/app/modules/share/sub-menu/sub-menu.component.scss ***!
  \****************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IiIsImZpbGUiOiJzcmMvYXBwL21vZHVsZXMvc2hhcmUvc3ViLW1lbnUvc3ViLW1lbnUuY29tcG9uZW50LnNjc3MifQ== */");

/***/ }),

/***/ "./src/app/modules/share/sub-menu/sub-menu.component.ts":
/*!**************************************************************!*\
  !*** ./src/app/modules/share/sub-menu/sub-menu.component.ts ***!
  \**************************************************************/
/*! exports provided: SubMenuComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SubMenuComponent", function() { return SubMenuComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");


let SubMenuComponent = class SubMenuComponent {
    constructor() { }
    ngOnInit() {
    }
};
SubMenuComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: 'app-sub-menu',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./sub-menu.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/modules/share/sub-menu/sub-menu.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./sub-menu.component.scss */ "./src/app/modules/share/sub-menu/sub-menu.component.scss")).default]
    })
], SubMenuComponent);



/***/ }),

/***/ "./src/app/modules/share/top-menu/top-menu.component.scss":
/*!****************************************************************!*\
  !*** ./src/app/modules/share/top-menu/top-menu.component.scss ***!
  \****************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IiIsImZpbGUiOiJzcmMvYXBwL21vZHVsZXMvc2hhcmUvdG9wLW1lbnUvdG9wLW1lbnUuY29tcG9uZW50LnNjc3MifQ== */");

/***/ }),

/***/ "./src/app/modules/share/top-menu/top-menu.component.ts":
/*!**************************************************************!*\
  !*** ./src/app/modules/share/top-menu/top-menu.component.ts ***!
  \**************************************************************/
/*! exports provided: TopMenuComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TopMenuComponent", function() { return TopMenuComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");


let TopMenuComponent = class TopMenuComponent {
    constructor() { }
    ngOnInit() {
    }
};
TopMenuComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: 'app-top-menu',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./top-menu.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/modules/share/top-menu/top-menu.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./top-menu.component.scss */ "./src/app/modules/share/top-menu/top-menu.component.scss")).default]
    })
], TopMenuComponent);



/***/ }),

/***/ "./src/app/service/core.service.ts":
/*!*****************************************!*\
  !*** ./src/app/service/core.service.ts ***!
  \*****************************************/
/*! exports provided: CoreService */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CoreService", function() { return CoreService; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_common_http__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/common/http */ "./node_modules/@angular/common/fesm2015/http.js");



let CoreService = class CoreService {
    constructor(http) {
        this.http = http;
    }
    getMenu() {
        console.log('called 2');
        return this.http.get('/api/menu/allmenuitem/');
    }
    getPageContent(data) {
        return this.http.get('/api/core/corePageDetail/' + data);
    }
    getAllPages() {
        return this.http.get('/api/core/corePageListWithMedia/');
    }
    getEvent() {
        return this.http.get('/api/core/event/');
    }
    getEventDetail(slug) {
        return this.http.get(`/api/core/event/${slug}/`);
    }
    //get faculty based on department id
    getFaculty() {
        // return this.http.get('/api/faculty/profilebydepartment/'+ id);
        return this.http.get('/api/faculty/Faculty/');
    }
    getDepartment() {
        return this.http.get('/api/department/Department');
    }
    getFacultyList() {
        return this.http.get('/api/faculty/faculty/');
    }
};
CoreService.ctorParameters = () => [
    { type: _angular_common_http__WEBPACK_IMPORTED_MODULE_2__["HttpClient"] }
];
CoreService = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Injectable"])({
        providedIn: 'root'
    })
], CoreService);



/***/ }),

/***/ "./src/environments/environment.ts":
/*!*****************************************!*\
  !*** ./src/environments/environment.ts ***!
  \*****************************************/
/*! exports provided: environment */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "environment", function() { return environment; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

const environment = {
    production: false
    // getOrigin:()=> `http://stfrancisschoolkorba.ac.in/api/`
};
/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.


/***/ }),

/***/ "./src/main.ts":
/*!*********************!*\
  !*** ./src/main.ts ***!
  \*********************/
/*! no exports provided */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_platform_browser_dynamic__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/platform-browser-dynamic */ "./node_modules/@angular/platform-browser-dynamic/fesm2015/platform-browser-dynamic.js");
/* harmony import */ var _app_app_module__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./app/app.module */ "./src/app/app.module.ts");
/* harmony import */ var _environments_environment__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./environments/environment */ "./src/environments/environment.ts");





if (_environments_environment__WEBPACK_IMPORTED_MODULE_4__["environment"].production) {
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["enableProdMode"])();
}
Object(_angular_platform_browser_dynamic__WEBPACK_IMPORTED_MODULE_2__["platformBrowserDynamic"])().bootstrapModule(_app_app_module__WEBPACK_IMPORTED_MODULE_3__["AppModule"])
    .catch(err => console.error(err));


/***/ }),

/***/ 0:
/*!***************************!*\
  !*** multi ./src/main.ts ***!
  \***************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(/*! C:\development\st-francis-school\st-francis-school-frontend\src\main.ts */"./src/main.ts");


/***/ })

},[[0,"runtime","vendor"]]]);
//# sourceMappingURL=main-es2015.js.map